/**
 * Utility functions for handling subscription actions and plan switching logic
 */

// Check if a plan switch is a cycle switch (monthly to annual or vice versa)
export const isCycleSwitchPlan = (user, plan) => {
    // Check plan types
    const isCurrentPlanSME = user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH ||
        user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR;

    const isCurrentPlanBasic = user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH ||
        user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR;

    const isTargetPlanSME = plan.priceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH ||
        plan.priceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR;

    const isTargetPlanBasic = plan.priceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH ||
        plan.priceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR;
        
    // Special cross-plan switches
    const isAnnualBasicToMonthlySME = 
        user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR && 
        plan.priceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH;
        
    const isMonthlyBasicToAnnualSME = 
        user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH && 
        plan.priceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR;
        
    const isMonthlySMEToAnnualBasic = 
        user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH && 
        plan.priceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR;
        
    const isAnnualSMEToMonthlyBasic = 
        user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR && 
        plan.priceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH;

    // Regular cycle switch (same plan level)
    const isRegularCycleSwitch = (isCurrentPlanSME && isTargetPlanSME) || (isCurrentPlanBasic && isTargetPlanBasic);
    
    // Cross plan cycle switch
    const isCrossPlanCycleSwitch = isAnnualBasicToMonthlySME || isMonthlyBasicToAnnualSME || 
                                  isMonthlySMEToAnnualBasic || isAnnualSMEToMonthlyBasic;
    
    return isRegularCycleSwitch || isCrossPlanCycleSwitch;
};

// Determine active plan index based on user's subscription
export const determineActivePlan = (user, activeTab) => {
    if (!user?.subscriptionStatus || user?.subscriptionStatus?.toUpperCase() !== 'ACTIVE') {
        return 0;
    }

    if (user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH && activeTab === "monthly") {
        return 2;
    } else if (user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR && activeTab !== "monthly") {
        return 2;
    } else if (user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH && activeTab === "monthly") {
        return 1;
    } else if (user?.activeSubscriptionPriceId === process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR && activeTab !== "monthly") {
        return 1;
    } else if (user?.activeSubscriptionPriceId === 'free') {
        return 3;
    } 
    
    return 0;
}; 